// Essential Identity Template - Common App Prompt #1
export const essentialIdentityTemplate = {
  id: 'essentialIdentity',
  title: 'Essential Identity',
  description: 'For backgrounds, identities, interests, or talents so meaningful your application would be incomplete without them',
  sections: [
    {
      id: 'the_moment_it_mattered',
      label: 'The Moment It Mattered',
      type: 'opening',
      prompt: 'When did you first realize this aspect of yourself wasn\'t just a detail, but something fundamental?',
      coachVoice: "I don't want 'I've always been...' Give me the specific moment when you understood this piece of your identity had real weight in the world.",
      sample: "The customs officer flipped through my passport, pausing at the visa stamps from three different countries in the past year. 'So where are you actually from?' he asked. I opened my mouth to give the simple answer, then realized I didn't have one anymore.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'why_this_defines_you',
      label: 'Why This Defines You',
      type: 'stakes', 
      prompt: 'What does this aspect of yourself demand from you that others might not understand?',
      coachVoice: "Don't just describe what makes you different. Show me what this identity requires of you - the responsibilities, challenges, or perspectives it forces you to carry.",
      sample: "Being a military kid doesn't just mean I've lived in eight states and four countries. It means I automatically scan every room for exit strategies, translate between groups who speak different cultural languages, and carry the weight of representing my family's service wherever I go.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'how_you_navigate_it',
      label: 'How You Navigate It',
      type: 'approach',
      prompt: 'Show me your unique way of living with, expressing, or managing this core part of yourself.',
      coachVoice: "This is where I want to see your specific approach to being who you are. What strategies, perspectives, or methods have you developed that others in your situation might not think of?",
      sample: "I created what I call 'cultural code-switching' - not just changing how I talk, but shifting my entire social approach depending on whether I'm with military families, local kids, or international students. I maintain different versions of my same authentic self, like speaking multiple dialects of my own personality.",
      minWords: 100,
      unlockWords: 50
    },
    {
      id: 'how_it_shapes_your_impact',
      label: 'How It Shapes Your Impact',
      type: 'growth',
      prompt: 'How does this core part of yourself change the way you contribute to communities and relationships?',
      coachVoice: "I want to see how your identity creates value for others. What do you bring to situations specifically because of who you are?",
      sample: "When our school's international club was splitting into cliques based on home countries, I found myself naturally becoming the bridge between groups. I realized my identity as a 'cultural chameleon' wasn't just about adapting - it was about helping others see past their own borders.",
      minWords: 80
    }
  ]
};